/* eslint-disable react/forbid-dom-props */ function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import { mergeStyles } from '@fluentui/react';
import SpzaComponent from './spzaComponent';
import { routes } from '@shared/routerHistory';
import { Constants } from '@shared/utils/constants';
import { SpzaInstrumentService } from '@shared/services/telemetry/spza/spzaInstrument';
import { getWindow } from '@shared/services/window';
import { NpsModule } from '@shared/utils/npsUtils';
import { addClassToElement, removeClassFromElements } from '@shared/utils/appUtils';
import { ExternalLink } from '@shared/components/externalLink';
import { logger } from '@src/logger';
import { Testimonials } from './Testimonials';
import classNames from 'classnames';
const RemoteHome = /*#__PURE__*/ React.lazy(()=>import('./FederatedModules/RemoteHome'));
class Home extends SpzaComponent {
    telemetryComponentDidMount() {
        var _getWindow_performance, _getWindow;
        const window = getWindow();
        const { navigationStart = 0, requestStart = 0 } = ((_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : (_getWindow_performance = _getWindow.performance) === null || _getWindow_performance === void 0 ? void 0 : _getWindow_performance.timing) || {};
        if (window) {
            window.loadTimeHomeFilters = performance.now() - (requestStart - navigationStart);
        }
    }
    componentDidMount() {
        this.telemetryComponentDidMount();
        const perfPayload = {
            page: getWindow().location.href,
            action: Constants.Telemetry.Action.PageLoad,
            actionModifier: Constants.Telemetry.ActionModifier.End
        };
        this.instrument.probe('logTelemetryInfo', perfPayload);
        logger.info('', {
            action: perfPayload.action,
            actionModifier: perfPayload.actionModifier
        });
        NpsModule.checkForNPS();
        if (document.getElementsByTagName('title')[0]) {
            document.getElementsByTagName('title')[0].innerHTML = this.context.loc('home_pageTitle');
        }
        removeClassFromElements('spza-accessibility-selected');
        addClassToElement(Constants.SearchBy.Id, 'uhfCatLogo', 'spza-accessibility-selected');
    }
    /// /////////////////////////////// Customer success story Tabs ///////////////////////////////////////
    viewMoreRecommendations() {
        const marginClass = mergeStyles({
            marginTop: '32px'
        });
        const linkClass = classNames({
            actionBannerButton: true,
            [marginClass]: true
        });
        return /*#__PURE__*/ _jsx(_Fragment, {
            children: /*#__PURE__*/ _jsx(ExternalLink, {
                href: "https://aka.ms/appsourcecustomerrecommendations",
                className: linkClass,
                accessibilityEnabled: true,
                target: "_blank",
                rel: "noreferrer",
                children: this.context.loc('Testimonials_View_More', 'View more recommendations >')
            })
        });
    }
    renderImpl() {
        const context = this.context;
        // home page needs both curated data and app data to exist, if it doesn't let's render a progress bar
        if (!this.props.allApps) {
            return null;
        }
        const { defaultSuccessStoryTab } = this.props;
        return /*#__PURE__*/ _jsxs("div", {
            className: "spza_homePage",
            role: "main",
            children: [
                /*#__PURE__*/ _jsx(RemoteHome, {}),
                /*#__PURE__*/ _jsxs("div", {
                    className: "section homeSuccessStory",
                    children: [
                        /*#__PURE__*/ _jsx("h3", {
                            className: "successStoryHeader",
                            children: context.loc('Home_SuccessStory_Title', 'Recommendations from customers')
                        }),
                        /*#__PURE__*/ _jsx(Testimonials, {
                            defaultTestimonialTabName: defaultSuccessStoryTab
                        }),
                        this.viewMoreRecommendations()
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "section homeMarketing",
                    children: [
                        /*#__PURE__*/ _jsx("span", {
                            className: "helpSectionTitle",
                            children: this.context.loc('Help_Section_Title')
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "marketContent",
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "cardContent",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "marketIcon icon-shop-50"
                                        }),
                                        /*#__PURE__*/ _jsx("h5", {
                                            className: "marketHeader",
                                            children: context.loc('Home_Marketing1Header')
                                        }),
                                        /*#__PURE__*/ _jsx("p", {
                                            className: "marketParagraph",
                                            children: context.loc('Home_Marketing1Content')
                                        }),
                                        /*#__PURE__*/ _jsx(ExternalLink, {
                                            href: "https://aka.ms/AppSourceDocOverview",
                                            className: "c-hyperlink supportLink",
                                            accessibilityEnabled: true,
                                            children: this.context.loc('App_LearnMore')
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "cardContent",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "marketIcon icon-shopping-cart-50"
                                        }),
                                        /*#__PURE__*/ _jsx("h5", {
                                            className: "marketHeader",
                                            children: context.loc('Home_Marketing2Header')
                                        }),
                                        /*#__PURE__*/ _jsx("p", {
                                            className: "marketParagraph",
                                            children: context.loc('Home_Marketing2Content')
                                        }),
                                        /*#__PURE__*/ _jsx(ExternalLink, {
                                            className: 'c-hyperlink supportLink',
                                            href: this.context.buildHref(routes.partners, {}, {}),
                                            accessibilityEnabled: true,
                                            children: this.context.loc('Sell_With_Us')
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "cardContent",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "marketIcon icon-what-this-50"
                                        }),
                                        /*#__PURE__*/ _jsx("h5", {
                                            className: "marketHeader",
                                            children: context.loc('Home_Marketing3Header')
                                        }),
                                        /*#__PURE__*/ _jsx("p", {
                                            className: "marketParagraph",
                                            children: context.loc('Home_Marketing3Content')
                                        }),
                                        /*#__PURE__*/ _jsx(ExternalLink, {
                                            href: "https://aka.ms/AppSourceContactUs",
                                            className: "c-hyperlink supportLink",
                                            accessibilityEnabled: true,
                                            children: this.context.loc('ContactUs')
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }
    constructor(props, context){
        super(props, context), _define_property(this, "context", void 0), _define_property(this, "instrument", void 0);
        this.instrument = SpzaInstrumentService.getProvider();
        this.state = {
            resultSearchID: 0
        };
    }
}
Home.contextTypes = {
    loc: PropTypes.func,
    locParams: PropTypes.func,
    buildHref: PropTypes.func,
    renderErrorModal: PropTypes.func
};
export default Home;
